//Command state
export const COMMAND_STATE = {
    ENGINE_STOPPED: "STOPPED",
    COMMAND_COMPLETE: "COMPLETE",
    COMMAND_PARTIAL_SUCCESS: "PARTIAL_SUCCESS",
    COMMAND_FAILED: "FAILED",
    ENGINE_STARTED: "STARTED",
    FOUND: "FOUND"
}

//Monitoring topics comands
export const MONITORING_COMMAND = {
    MONITORING_TRANSACTIONS: 'transactions',
    MONITORING_ENGINE: 'state/engine',
    MONITORING_DISCOVERY: 'state/discovery',
    MONITORING_ENROL: 'state/enroll',
    MONITORING_QUEUE: 'state/queue',
    MONITORING_DEVICE: 'state/device2',
    MONITORING_TASKS: 'state/tasks',

    TOPIC_DEVICE: 'topic/device2',
    TOPIC_COUNT: 'topic/count',
    TOPIC_TASK: 'topic/task',
    TOPIC_PING: 'topic/ping',
    
    MONITORING: 'MONITORING',
}

// Certificate commands
export const CERTIFICATE_COMMAND = {
    SEND_CERTIFICATE_COMPLETE: 'COMPLETE'
}

// Filter commands
export const FILTER_COMMAND = {
    FILTER: 'FILTER',
}

export const HEART_BEAT_COMMAND = {
    HEART_BEAT: 'HEART_BEAT',
}

//Monitoring topics command state
export const MONITORING_COMMAND_STATE = {
    MONITORING_STOP: 'STOP',
    MONITORING_START: 'START'
}

//Additional information we can send along with our request.
export const CUSTOM_VALUES = {
    NO_REFRESH: 'NO_REFRESH',
    ALARMS_ONLY: 'ALARMS_ONLY'
}

//Event action keys
export const EVENT_ACTION_KEYS = {
    ALL_ALLOWED_KEY: "ALLOWED",
    ALL_DENIED_KEY: "DENIED",
    ASSIGN_KEY: "ASSIGN",
    UNASSIGN_KEY: "UNASSIGN",
}

//ErrorStatus
export const MESSAGE_OVERLOAD_ERROR = 'http:429 - too many messages.'

//Enroll
export const ENROLL_TYPE = {
    ENROLL: "ENROLL",
    ENROLL_IDEMIA_FINGER: "ENROLL_IDEMIA_FINGER",
    ENROLL_IDEMIA_FACE: "ENROLL_IDEMIA_FACE",
    ENROLL_IDEMIA_HAND: "ENROLL_IDEMIA_HAND",
    ENROLL_CONTROLID_FINGER: "ENROLL_CONTROLID_FINGER",
    ENROLL_CONTROLID_FACE: "ENROLL_CONTROLID_FACE",
    ENROLL_QR_CODE: "ENROLL_QR_CODE",
    ENROLL_HIKVISION_FINGER: "ENROLL_HIKVISION_FINGER",
    ENROLL_HIKVISION_FACE: "ENROLL_HIKVISION_FACE",
}